import type { AgentAnswers } from "./reviewRow.types";

export type AiBacking = "all" | "one" | "none" | null;

export function aiBacking(
  agent: AgentAnswers | null | undefined,
  pickedPath: string | null,
): AiBacking {
  const answers = agent?.answers ?? [];
  const withPath = answers.filter((a) => a.path);
  if (!pickedPath || withPath.length === 0) return null;
  const hits = withPath.filter((a) => a.path === pickedPath).length;
  return hits === answers.length ? "all" : hits > 0 ? "one" : "none";
}
